import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { EcryptServiceService } from './ecrypt-service.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatBotFlowsService {


  url = environment.serverAPI8 + "/api/chat/bot-flows";

  crmSettingsData: any;
  whatsappVendorId: any;
  whatsappContactId: any;

  constructor(private httpClient: HttpClient, private ecryptService: EcryptServiceService) { }

  getBotFlows(page: number, size: number, search?: string): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (search) {
      params = params.set('search', search);
    }

    return this.httpClient.get<any>(`${this.url}/list-data`, { params });
  }
  addBotFlow(data: any,): Observable<any> {
    return this.httpClient.post(`${this.url}/add-process`, data);
  }
  updateProcess(payload: unknown): Observable<any> {
    return this.httpClient.post<any>(`${this.url}/update-process`, payload);
  }

  deleteBotFlow(botFlowId: string): Observable<any> {
    const url = `${this.url}/${botFlowId}/delete-process`;
    return this.httpClient.delete(url);
  }


  searchBotFlow(query: string, page: number, size: number, sort: string): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,

    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;


    return this.httpClient.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  deleteProcess(uid: string): Observable<any> {
   

    return this.httpClient.delete<any>(`${this.url}/${uid}/delete-process`);
  }

  isLoading = new Subject<boolean>();

  show() {
    this.isLoading.next(true);
    
  }

  uploadBotFlows(payload: unknown): Observable<any> {
    return this.httpClient.post<any>(`${this.url}/bulk/import`, payload);
  }
}
